// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c63a299f","682":"daee51e8"}[chunkId] + ".chunk.js";
};